export const CSS_VARIABLE_PREFIXES = {
  COLOR: "",
  COLOR_CHART: "chart",
  FONT_PREFIX: "font",
  FONT_SIZE_PREFIX: "font-size",
  LINE_HEIGHT_SPACING: "line-height",
  LETTER_SPACING_PREFIX: "letter-spacing",
  SHADOW: "",
  SPACING_PREFIX: "spacing",
};
